var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0894 10.2305V10.9805C16.0894 11.183 15.9319 11.348 15.7219 11.3555H14.6269C14.2294 11.3555 13.8694 11.063 13.8394 10.673C13.8169 10.4405 13.9069 10.223 14.0569 10.073C14.1919 9.93047 14.3794 9.85547 14.5819 9.85547H15.7144C15.9319 9.86297 16.0894 10.028 16.0894 10.2305Z",
    fill: "url(#paint0_linear_6533_10158)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4909 9.51797C13.1159 9.88547 12.9359 10.433 13.0859 11.003C13.2809 11.7005 13.9634 12.143 14.6834 12.143H15.3359C15.7484 12.143 16.0859 12.4805 16.0859 12.893V13.0355C16.0859 14.588 14.8184 15.8555 13.2659 15.8555H4.65594C3.10344 15.8555 1.83594 14.588 1.83594 13.0355V7.98797C1.83594 7.06547 2.27844 6.24797 2.96094 5.73797C3.43344 5.37797 4.01844 5.16797 4.65594 5.16797H13.2659C14.8184 5.16797 16.0859 6.43547 16.0859 7.98797V8.31797C16.0859 8.73047 15.7484 9.06797 15.3359 9.06797H14.5709C14.1509 9.06797 13.7684 9.23297 13.4909 9.51797Z",
    fill: "url(#paint1_linear_6533_10158)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1513 3.615C12.3538 3.8175 12.1813 4.1325 11.8963 4.1325L6.13626 4.125C5.80626 4.125 5.63376 3.72 5.87376 3.4875L7.08876 2.265C8.11626 1.245 9.78126 1.245 10.8088 2.265L12.1213 3.5925C12.1288 3.6 12.1438 3.6075 12.1513 3.615Z",
    fill: "url(#paint2_linear_6533_10158)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6533_10158",
    x1: 13.8359,
    y1: 10.6083,
    x2: 16.0894,
    y2: 10.6083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0D09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCC95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6533_10158",
    x1: 1.83594,
    y1: 10.5319,
    x2: 16.0859,
    y2: 10.5319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0D09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCC95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6533_10158",
    x1: 5.76172,
    y1: 2.82122,
    x2: 12.2394,
    y2: 2.82122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0D09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCC95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.58bbabccfb32c023cba2f9f8b2cb6d96.svg";
export { ForwardRef as ReactComponent };